import React, { useState } from 'react';
import ClearChip from '../../../../components/ClearChip';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField as TextFieldMaterial } from '@mui/material';
import { Field } from 'react-final-form';
import * as authService from '../../../../services/auth';
import { getUserFullName } from '../../../../helpers/user';

const RescuerField = ({ rescuersList, form }) => {
  const values = form.getState().values;
  const [showRescuerSelector, setShowRescuerSelector] = useState(false);

  const releaseRescue = form => () => {
    const user = authService.getCurrentlyLoggedInOrImpersonatingUser();
    setShowRescuerSelector(true);
    form.batch(() => {
      form.change('rescuer_id', null);
      form.change('rescuer', null);
      form.change('released_by_id', user.id);
      form.change('releaser', getUserFullName(user));
    });
  };

  return (
    <Field
      name="rescuer"
      render={({ input, meta }) => {
        if (values.rescuer) {
          return (
            <ClearChip
              value={input.value}
              onClick={() => {
                input.onChange(null);
                form.change('rescuer_id', null);
              }}
            />
          );
        }

        if (!showRescuerSelector && values.adopter && values.rescuer_id === null && values.released_by_id === null) {
          return <ClearChip value={values.adopter} onClick={releaseRescue(form)} />;
        }

        return (
          values.rescuer_id === null && (
            <Autocomplete
              options={rescuersList}
              sx={{ minWidth: 300 }}
              getOptionLabel={res => (res ? res.name : '')}
              onChange={(event, rescuer) => {
                input.onChange(rescuer.value);
                form.change('rescuer_id', rescuer.id);
              }}
              onBlur={input.onBlur}
              onFocus={input.onFocus}
              size="small"
              renderInput={params => (
                <TextFieldMaterial {...params} placeholder="Rescuer" variant="outlined" fullWidth />
              )}
              noOptionsText="There are no active rescuers in the Site"
            />
          )
        );
      }}
    />
  );
};

export default RescuerField;
